import EntityStatusFilterTabs from '../../../components/shared/EntityStatusFilterTabs';
import type { MerchantRow } from '../models/types';

type MerchantFiltersProps = {
  filterStatus: string;
  onFilterStatusChange: (value: string) => void;
  loading: boolean;
  statsMerchants: MerchantRow[];
};

export default function MerchantFilters({
  filterStatus,
  onFilterStatusChange,
  loading,
  statsMerchants,
}: MerchantFiltersProps) {
  return (
    <EntityStatusFilterTabs
      filterStatus={filterStatus}
      onFilterStatusChange={onFilterStatusChange}
      loading={loading}
      items={statsMerchants}
      ariaLabel="Merchant status"
    />
  );
}
